import type { ReactNode } from 'react';
import { CommunioDiscoveryLayout } from '@/platform/layout/CommunioDiscoveryLayout';

export type TenantDiscoveryLayoutProps = {
  children: ReactNode;
  right?: ReactNode;
  hideSidebar?: boolean;
};

/** Communio product siteShell — repo default (paydirt vertical swaps siteShell.paydirt.tsx). */
export function TenantDiscoveryLayout({ children, right, hideSidebar }: TenantDiscoveryLayoutProps) {
  return (
    <CommunioDiscoveryLayout right={right} hideSidebar={hideSidebar}>
      {children}
    </CommunioDiscoveryLayout>
  );
}
